import { ApiResponse, Service } from '@roc/feature-app-core';

const url = {
  LOAN_DETAILS: '/nportal/rest/priv/loan/getLoanByIdInternalPortal',
  DOCUMENT_DETIALS: '/nportal/rest/priv/loanDocs/getLoanDocumentById',
  ORDER_SECOND_APPRAISAL: '/nportal/rest/priv/valueLink/orderSecondAppraisal',

  GET_LOAN_PROPERTIES: '/api/v1/loan/getLoanPropertiesByLoanId',
  GET_PROPERTIES_WITH_SECOND_APPRAISAL_PAYMENT_DONE:
    '/nportal/rest/priv/valueLink/getPropertiesWithSecondAppraisalPaymentDone',
  SEND_LINK_TO_UW_CHATROOM:
    '/nportal/rest/priv/valueLink/sendSecondAppraisalPaymentLinkMessageToChatRoom',

  GET_SECOND_APPRAISAL_LINK_IF_PROPERTIES_ALREADY_SELECTED_FOR_PAYMENT:
    '/nportal/rest/priv/valueLink/getSecondAppraisalLinkIfPropertiesAlreadySelectedForPayment',

  GET_SECOND_APPRAISAL_INFORMATION:
    '/nportal/rest/priv/valueLink/getSecondAppraisalInformation',
};

export class SecondAppraisalService extends Service {
  orderSecondAppraisal(
    loanId: string,
    propertyIds: string[],
    paymentDone: boolean
  ) {
    return this.post(url.ORDER_SECOND_APPRAISAL, {
      loanId,
      propertyIds,
      paymentDone,
    });
  }

  getLoanProperties(loanId: string) {
    return this.get(`${url.GET_LOAN_PROPERTIES}/${loanId}`);
  }

  getSecondAppraisalInformation(loanId: string) {
    return this.get(`${url.GET_SECOND_APPRAISAL_INFORMATION}?loanId=${loanId}`);
  }

  getPropertiesWithSecondAppraisalPaymentDone(loanId: string) {
    return this.get(url.GET_PROPERTIES_WITH_SECOND_APPRAISAL_PAYMENT_DONE, {
      loanId,
    });
  }

  getSecondAppraisalLinkIfPropertiesAlreadySelectedForPayment(loanId: string) {
    return this.get(
      url.GET_SECOND_APPRAISAL_LINK_IF_PROPERTIES_ALREADY_SELECTED_FOR_PAYMENT,
      { loanId }
    );
  }

  sendLink(loanId: string) {
    return this.get(url.SEND_LINK_TO_UW_CHATROOM, { loanId });
  }
}
